import { config } from "../../utils/constants";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UpcomingDonations from "./UpcomingDonation";
import { todayDate } from "../../common/DateFormatters";

const BloodDonationSummary = ({
  setRequestStep,
  barCode,
  pastDonation,
  cardProfile,
  showLogin,
  isLiferay,
  isLogin,
  donorDetails,
  pastDonationLength,
  userName,
  translationMap
}) => {
  const navigate = useNavigate();
  const [lengthOfPastDonations, setLengthOfPastDonations] = useState(0);
  useEffect(() => {
    if (pastDonation) {
      const len = pastDonationLength;
      setLengthOfPastDonations(len);
      //console.log("length of pastdonation", len);
      const element = document.getElementsByClassName(
        "blood_donation_health_card"
      )[0];
      //console.log("card element", element);
      if (element) {
        if (len > 0 && len <= 10) {
          element?.classList.add("blue_heath_card");
        } else if (len > 10 && len <= 20) {
          element?.classList.add("silver_heath_card");
        } else if (len > 20 && len <= 30) {
          element?.classList.add("gloden_heath_card");
        } else if (len > 30 && len <= 40) {
          element?.classList.add("platinum_heath_card");
        } else if (len > 40) {
          element?.classList.add("pearl_heath_card");
        }
      }
    }
    Carousel();
  }, [pastDonation, pastDonationLength]);

  const dateConvert = (dateString) => {
    const [day, month, year] = dateString.split("-");
    const date = new Date(`${year}-${month}-${day}`);
    if (isNaN(date)) {
      throw new Error(`Invalid date: ${dateString}`);
    }
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric"
    });
  };

  const convertToAmPm = (time) => {
    const [hour, minute] = time.split(":").map(Number);
    const amPm = hour >= 12 ? "PM" : "AM";
    const adjustedHour = hour % 12 || 12;
    return `${adjustedHour.toString().padStart(2, "0")}:${minute
    .toString()
    .padStart(2, "0")} ${amPm}`;
  };

  function Carousel() {
    document.addEventListener("DOMContentLoaded", function () {
      const summaryBoxes = document.querySelectorAll(".bd_summary_box");
      const dotsContainer = document.querySelector(".bd_summary_dots");
      const dotsWrapper = document.querySelector(".bd_summary_dots_wrapper");

      // Create dots dynamically
      summaryBoxes.forEach((box, index) => {
        const dot = document.createElement("span");
        dot.classList.add("dot");
        dot.dataset.index = index;
        dotsContainer.appendChild(dot);
      });

      const dots = document.querySelectorAll(".bd_summary_dots .dot");

      // Hide the first dot
      if (dots.length > 0) {
        dots[0].style.display = "none";
      }

      // Enable horizontal scrolling on dotsWrapper with mouse wheel
      if (dotsWrapper) {
        dotsWrapper.addEventListener("wheel", (event) => {
          event.preventDefault(); // Prevent vertical scroll
          dotsWrapper.scrollLeft += event.deltaY; // Allow smooth horizontal scroll
        });
      }

      // Click event for smooth scrolling
      dots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
          summaryBoxes[index].scrollIntoView({ behavior: "smooth", block: "center" });
        });
      });

      // Observe sections for active dot
      const observer = new IntersectionObserver(
        (entries) => {
          let maxVisibility = 0;
          let mostVisibleIndex = -1;

          entries.forEach((entry) => {
            const index = [...summaryBoxes].indexOf(entry.target);
            if (entry.isIntersecting) {
              const visibility = entry.intersectionRatio; // How much is visible
              if (visibility > maxVisibility) {
                maxVisibility = visibility;
                mostVisibleIndex = index;
              }
            }
          });

          if (mostVisibleIndex > 0) {// Avoid activating the first (hidden) dot
            dots.forEach((dot, i) => dot.classList.toggle("active", i === mostVisibleIndex));

            // Move dots container
            const activeDot = dots[mostVisibleIndex];
            if (dotsWrapper && activeDot) {
              const dotsContainerWidth = dotsWrapper.clientWidth;
              const activeDotOffset = activeDot.offsetLeft;
              dotsWrapper.scrollLeft = activeDotOffset - dotsContainerWidth / 2 + activeDot.clientWidth / 2;
            }
          }
        },
        { threshold: [0.5, 0.75, 1] } // More precise visibility detection
      );

      summaryBoxes.forEach((box) => observer.observe(box));
    });

  }

  const pastDonations = pastDonation?.slice(0, 2);
  return (
    <>
      {donorDetails || cardProfile ?
      <div className="cover_main_box2 sidebar-center">
          <div className="responsive_title_box1">
            <h6 className="MainTitleOne">{translationMap?.welcomeToDammi}</h6>
          </div>
          {cardProfile && pastDonation?.length > 0 ?
        <div className="blood_donation_health_card">
              <div className="logo_box">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a>
                  <img
                src={
                lengthOfPastDonations <= 40 ?
                `${config.assestsBase}img/blood_health_card_logo.png` :
                `${config.assestsBase}img/blood_health_card_dark_logo.svg`
                }
                alt="Donor color logo" />
              
                </a>
              </div>
              <div className="content_box">
                <div className="inner_box">
                  <p className="small_txt">{translationMap?.donorName}</p>
                  <h6 className="big_title">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a>
                      {cardProfile?.name} {cardProfile?.surname}
                    </a>
                  </h6>
                </div>
                <div className="inner_box">
                  <p className="small_txt">{translationMap?.donorNum}</p>
                  <h6 className="big_title">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a>{cardProfile?.card}</a>
                  </h6>
                </div>
              </div>
              <div className="content_box2">
                <p className="small_txt">
                  {translationMap?.proudToBe}{" "}
                  {/* <span> {translationMap?.blood} </span> {translationMap?.donor} */}
                </p>
              </div>
              <div className="drop-shape">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                <a href="javascript:;">{cardProfile?.bloodGroup}</a>
              </div>
            </div> :

        cardProfile &&
        <div className="Info_Note_Box">
                <span className="icon_box">
                  <i className="material-symbols-outlined">info</i>
                </span>
                <div className="content_box">
                  <p>{translationMap?.noPastDonationsText}</p>
                </div>
              </div>

        }
          <div className="donation_summary_box">
            <h6 className="MainTitleOne">
              {translationMap?.donationSummary}
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a className="view_link" onClick={() => {
              setRequestStep(11);
              window.parent.scrollTo(0, 0);
            }}>
                {translationMap?.viewAll}
                <i className="material-symbols-outlined">arrow_forward_ios</i>
              </a>
            </h6>
            <p className="small_title">{translationMap?.upcomingDonations}</p>
            {barCode ?
          <div className="blood_donation_summary_box blood_donation_summary_cloumn_box">
                <div className="bd_summary_box bd_summary_box3">
                  <div className="bd_summary_text_box">
                    <p className="date_text" style={{ direction: "ltr" }}>
                      {todayDate()}
                    </p>
                    <p className="Gray_Title bottom_text bottom_text_italic">
                      {translationMap?.codeValidToday}
                    </p>
                  </div>
                  <div className="bd_summary_icon_box">
                    <img
                  src={`data:image/png;base64,${barCode}`}
                  alt="Displaying barcode" />
                
                  </div>
                </div>
              </div> :

          <div>{translationMap?.noEvents}</div>
          }

            {pastDonations &&
          <>
                <p className="small_title">{translationMap?.pastDonations}</p>
                <div className="blood_donation_summary_main_box">
                  <div className="blood_donation_summary_box blood_donation_summary_cloumn_box">
                    {pastDonations.map((item, index) =>
                <div className="bd_summary_box" key={item.id}>
                          <div className="bd_summary_icon_box">
                            <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      
                              <path
                        d="M28.3334 20.3327C28.3334 24.751 24.7517 28.3327 20.3334 28.3327C15.9151 28.3327 12.3334 24.751 12.3334 20.3327C12.3334 14.5811 20.3334 1.66602 20.3334 1.66602C20.3334 1.66602 28.3334 14.5811 28.3334 20.3327Z"
                        stroke="#002F70"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      
                              <path
                        d="M9.66675 10.9993C9.66675 13.2085 7.87589 14.9993 5.66675 14.9993C3.45761 14.9993 1.66675 13.2085 1.66675 10.9993C1.66675 8.12354 5.66675 1.66602 5.66675 1.66602C5.66675 1.66602 9.66675 8.12354 9.66675 10.9993Z"
                        stroke="#002F70"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      
                            </svg>
                          </div>
                          <div className="bd_summary_text_box">
                            <p className="date_text" style={{ direction: "ltr" }}>
                              {dateConvert(item.date)}
                              <span style={{ direction: "ltr" }}>{convertToAmPm(item.time)}</span>
                            </p>
                            <div className="bd_title">
                              <h6 className="Gray_Title bottom_text">
                                {translationMap?.donation} #{index + 1}
                              </h6>
                            </div>
                            <p className="Gray_Title bottom_text">
                              {item.location}
                            </p>
                          </div>
                        </div>
                )}
                  </div>
                  <div className="bd_summary_dots">

                  </div>
                </div>
              </>
          }
          </div>
        </div> :
      !isLiferay && userName && barCode ?
      <div className="cover_main_box2">
            <div className="responsive_title_box1">
            <h6 className="MainTitleOne">{translationMap?.welcomeToDammi}</h6>
          </div>
        <div className="Info_Note_Box">
          <span className="icon_box">
            <i className="material-symbols-outlined">info</i>
          </span>
          <div className="content_box">
            <p>{translationMap?.noPastDonationsText}</p>
          </div>
        </div>
        {barCode &&
        <UpcomingDonations
          barCode={barCode}
          translationMap={translationMap} />

        }
        </div> :
      isLiferay && isLogin ?
      <>
          <div className="cover_main_box2">
          <div className="responsive_title_box1">
            <h6 className="MainTitleOne">{translationMap?.welcomeToDammi}</h6>
          </div>
            <div className="Info_Note_Box">
              <span className="icon_box">
                <i className="material-symbols-outlined">info</i>
              </span>
              <div className="content_box">
                <p>{translationMap?.noPastDonationsText}</p>
              </div>
            </div>
            <div className="inner_content_box">
              <div className="top_title_box">
                <h6 className="MainTitleOne">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a>{translationMap?.alreadyADonor || "Already a donor?"}</a>
                </h6>
              </div>
              <div className="btn_box">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                className="bluetrans_btn_link"
                onClick={() => navigate("/link-account")}>
                
                  {translationMap?.linkDonorAccount || "Link Donor Account"}
                </a>
              </div>
            </div>
            {barCode &&
          <UpcomingDonations
            barCode={barCode}
            translationMap={translationMap} />

          }
          </div>
        </> :
      (isLogin || !isLiferay) &&
      <div class="cover_main_box2">

        <div className="Info_Note_Box">
          <span className="icon_box">
            <i className="material-symbols-outlined">info</i>
          </span>
          <div className="content_box">
            <p>{translationMap?.noPastDonationsText}</p>
          </div>
        </div>
        </div>
      }
    </>);

};

export default BloodDonationSummary;